// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_1HGp0","listWrap":"index_listWrap_Uxhaq","content":"index_content_1Z1ve"};